import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  currencyFormat,
  /* formatDateTime, */ formatDateWithAMPM,
} from "../../../../common/Validations";
import { addInvoiceID } from "../../../../redux/feature/customer_app/preSalesSlice";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { getCustomerV2Invoice } from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import { hasAccess } from "../../../../utils/roleUtils";
import { InvoiceReceiptCell } from "../../../../Components/AccountsFlow/SourceReceipt";
import useDocNav from "../../../accounts_flow/useDocNav";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import FlowStatusHistory from "../../../../Components/FlowStatusHistory/flowStatusHistory";
import { orderNr } from "../../../../redux/feature/customer_app/customerV1Slice";
import EwayBillConfirmationModal from "../../Customer_V2/Scheduling/EwayBillConfirmationModal";
import CommonFilterCustomerV2 from "../../Customer_V2/Common/CommonFilterCustomerV2";
const CustInvoiceListV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Order");
  localStorage.setItem("submenu", "Invoice");

  let invoiceListData = useSelector((state) => state?.customer?.invoice); // User Details from Store
  let invoiceListDataTable = useSelector(
    (state) => state?.customer?.invoice?.pagination,
  ); // User Details from Store

  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig); // Config Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [getModalEwayBill, setModalEwayBill] = useState(false);
  const [ewayBillData, setEwayBillData] = useState(null);

  const [userRole, setUserRole] = useState(null);
  const [pageConfigInfo, setPageConfigInfo] = useState(null);

  const [filterShow, setFilterShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const detailedPageInvoice = (invoiceNumber, manula) => {
    dispatch(addInvoiceID(invoiceNumber));
    if (manula) {
      navigate(Constants.CUSTOMER_V2_MANUAL_INVOICE_DETAILS);
    } else {
      navigate(Constants.CUSTOMER_V2_INVOICE_DETAILS);
    }
  };
  const detailedPageOrder = (orderID) => {
    dispatch(orderNr(orderID));
    navigate(CustomerConstants.CUSTOMER_V2_ORDER_BOOKING_UPDATE);
  };
  // Invoice Table Col
  const docNav = useDocNav();
  const invoiceDataColumns = [
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row?.manualInvoice)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Invoice Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {/* {formatDateTime(row.createdAt)} */}
            {formatDateWithAMPM(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row?.totals?.totalNetValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold text-primary">
          ₹ {currencyFormat(Number(row?.totals?.totalNetValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Sales Invoice Nr",
    //   id: "accountsVoucherNo",
    //   selector: (row) => row.accountsVoucherNo,
    //   cell: (row) => (
    //     <button
    //       className="btnInfo"
    //       onClick={() =>
    //         detailedPageInvoice(row.accountsVoucherNo, row?.manualInvoice)
    //       }
    //     >
    //       {row.accountsVoucherNo}{" "}
    //     </button>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    // {
    //   name: "SalesInv Voucher",
    //   id: "accountsVoucherNo",
    //   selector: (row) => row?.accountsVoucherNo || "",
    //   cell: (row) => (
    //     <span className="fw-bold">{row?.accountsVoucherNo || "-"}</span>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Receipt",
      id: "receiptStatus",
      cell: (row) => (
        <InvoiceReceiptCell
          cancelled={/cancel/i.test(row.invoiceStatusHeader || "")}
          source={{
            type: "INVOICE",
            invoiceNr: row.documentNumber,
            loadingAdviceNr: row.loadingAdviceNr,
            orderNo: row.orderSchedulingNr,
            customerCode: row.customerCode,
            partyName: row.customerName,
          }}
        />
      ),
      width: "190px",
    },
    {
      name: "Workflow log",
      selector: (row) => row.flowStatusHistory?.length || 0,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center iconTable"
        >
          <img
            src="assets/img/newIcons/workflow.png"
            alt="Workflow log"
            title="View workflow history"
            style={{
              width: "35px",
              cursor: "pointer",
            }}
            className="mt-1"
            onClick={() => showStatusInfo(row.flowStatusHistory || [])}
          />
        </div>
      ),
      sortable: false,
      width: "132px",
    },
    {
      name: "Sales Invoice Voucher Details",
      id: "accountsVoucherNo",
      selector: (row) => row?.accountsVoucherNo || "",
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <span className="fw-bold">
            Voucher No: {row?.accountsVoucherNo || "-"}
          </span>

          <span className="fw-bold text-success">
            Status: {row?.accountsSyncStatus || "-"}
          </span>

          <span className="text-muted small">
            Created At:{" "}
            {row?.accountsSyncedAt
              ? new Date(row.accountsSyncedAt).toLocaleString()
              : "-"}
          </span>
        </div>
      ),
      sortable: true,
      width: "280px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.invoiceStatusHeader}
    //       </span>
    //     </>
    //   ),
    //   width: "180px",
    // },
    // Conditionally include the 'workflowActionLogs' column

    // {
    //   name: "Status",
    //   selector: (row) => row.invoiceStatusHeader,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.invoiceStatusHeader} />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Company",
    //   id: "companyCodeDesc",
    //   selector: (row) => row.companyCode,
    //   cell: (row) => (
    //     <>
    //       <span className="fw-bold text-success">{row.companyCodeDesc}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },

    {
      name: "Company / Customer",
      id: "companyCodeDesc",
      selector: (row) =>
        `${row.companyCodeDesc || ""} ${row.customerName || ""} ${row.sapDocumentNumber || ""}`,
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <p className="m-0 p-0 fw-bold">{row.customerName || "-"}</p>
          {/* <p className="m-0 p-0">{row.customerCode || "-"}</p> */}
          <span className="fw-bold text-success">
            {row.companyCodeDesc || "-"}
          </span>
        </div>
      ),
      sortable: true,
      width: "220px",
      wrap: true,
    },
    {
      name: "Loading Nr",
      id: "loadingAdviceNr",
      cell: (row) =>
        row.loadingAdviceNr ? (
          <button
            className="btnInfo"
            title="Open loading advice"
            onClick={() => docNav.openLoadingAdvice(row.loadingAdviceNr)}
          >
            {row.loadingAdviceNr}
          </button>
        ) : (
          "--"
        ),
      width: "150px",
    },
    {
      name: "Order Nr",
      id: "orderSchedulingNr",
      selector: (row) => row.orderSchedulingNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageOrder(row.orderSchedulingNr)}
        >
          {row.orderSchedulingNr || "-"}
        </button>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "E-Way Bill Details",
      id: "e_WayBillNo",
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <p className="bg-table-status bg-table-new-status mb-0">
            {row?.e_WayBillNo || "--"}
          </p>
          <p className="bg-table-status bg-table-success-status mb-0">
            {row?.e_WayBillStatus || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "E-Way Bill Print",
      cell: (row) => (
        <>
          {row.e_WayBillNo ? (
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-center"
            >
              <img
                src="assets/img/newIcons/delivery-truck.png"
                alt="attachments"
                style={{ width: "40px" }}
                className="mt-1"
                onClick={() => showEwayBill(row)}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Sales Officer Details",
      id: "salesOfficerDetails",
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <span className="fw-bold">{row?.salesOfficerName || "--"}</span>
          <span>Officer Code: {row?.salesOfficerCode || "--"}</span>
          <span>Contact: {row?.salesOfficerContactNr || "--"}</span>
          <span className="text-muted small">
            Email: {row?.salesOfficerEmail || "--"}
          </span>
        </div>
      ),
      sortable: true,
      width: "260px",
    },
    {
      name: "Cancelled Invoice Details",
      id: "cancelledInvoiceDetails",
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <span>INV Cancelled Date: {row?.cancelledInvoiceDate || "--"}</span>
          <span className="text-muted small">
            Cancelled Remark: {row?.cancelledInvoiceRemark || "--"}
          </span>
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Action",
      selector: (row) => row.dispatchDate,
      cell: (row) => (
        <>
          <button
            className="btnTable btn-danger"
            // onClick={() => showCancel(row)}
          >
            Cancel
          </button>
        </>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  // Invoice Item Table Col
  const lineItemColInfo = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQtyLoadConfirm} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Unit Price",
      cell: (row) => <span>{row?.unitPrice} </span>,
      width: "100px",
    },
    {
      name: "Basic Price",
      selector: (row) => row?.basicPrice || "--",
      cell: (row) => <span>{row?.basicPrice} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Driver",
    //   selector: (row) => row?.netValue || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName} </p>
    //       <p className="m-0 p-0 ">{row?.transporterDriverContact} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Truck No",
    //   selector: (row) => row?.netValue || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTruckNo} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
  ];

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getCustomerInvoiceList",

      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCustomerV2Invoice(obj));
    setData(invoiceListData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCustomerV2Invoice(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getCustomerV2Invoice(obj));
    setData(invoiceListData?.data);
  };

  const loadInitialPOData = async () => {
    setData(invoiceListData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceListData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getCustomerV2Invoice(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showEwayBill = (rowData) => {
    setModalEwayBill(true);
    setEwayBillData(rowData);
  };
  const hideEwayBillModal = () => {
    setModalEwayBill(false);
    setEwayBillData(null);
  };

  const navigateTomanualInvoice = () => {
    navigate(CustomerConstants.CUSTOMER_V2_MANUAL_INVOICE_CREATION);
  };

  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, userData]);

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(getCustomerV2Invoice(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Invoice</h2>
                <p className="subText">Lists of Invoice and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={invoiceDataColumns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IN</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Invoice List</span>
                      <span className="subHeaderTitle">
                        View of Invoice and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      {hasAccess(
                        userRole,
                        "buttons",
                        "customer_details_edit",
                        pageConfigInfo,
                      ) && (
                        <Col xs={6} md={6} lg={6}>
                          <button
                            className="btnTable"
                            onClick={navigateTomanualInvoice}
                          >
                            Manual Invoice
                          </button>
                        </Col>
                      )}
                      <Col xs={6} md={1} lg={1}>
                        <SourcingCommonFilter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 150, 300]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={invoiceDataColumns}
                          data={data}
                          progressPending={invoiceListData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={invoiceListDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <EwayBillConfirmationModal
        show={getModalEwayBill}
        onHide={() => hideEwayBillModal()}
        ewaybill={ewayBillData}
      />
      <FlowStatusHistory
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
    </main>
  );
};

export default CustInvoiceListV2;
